// extracted by mini-css-extract-plugin
export default {"loginHead":"login_loginHead__l7-1o","loginMain":"login_loginMain__+q8ny","loginBox":"login_loginBox__1uPmv"};